import {
  Popover, PopoverTrigger, PopoverContent, PopoverBody, IconButton, Button, Divider, Flex,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { OptionMenu, Row, SectionLabel, SlidersIcon } from '../movements/DisplayMenu';
import { GROUP_BY_OPTIONS, GROUP_BY_TYPE } from '../../utils/accountGrouping';

/**
 * The Accounts page's Display popover: the sliders button of the top bar, as
 * on Movements, holding how the list is grouped (by type, by institution or
 * by age).
 */
export default function AccountsDisplayMenu({ groupBy, onGroupByChange }) {
  const { t } = useTranslation('accounts');
  const { t: tm } = useTranslation('movements');
  const options = GROUP_BY_OPTIONS.map((value) => ({
    value, label: t(`groupBy.${value}`),
  }));
  return (
    <Popover placement="bottom-end" isLazy>
      <PopoverTrigger>
        <IconButton
          icon={<SlidersIcon boxSize={4} />}
          aria-label={tm('display.button')}
          title={tm('display.button')}
          size="sm"
          variant="ghost"
          color="redesign.text.muted"
          _hover={{ color: 'redesign.heading', bg: 'redesign.bg.card' }}
        />
      </PopoverTrigger>
      <PopoverContent w="300px" borderRadius="xl" boxShadow="lg" _focus={{ boxShadow: 'lg' }}>
        <PopoverBody p={2.5}>
          <SectionLabel>{tm('display.sections.layout')}</SectionLabel>
          <Row label={t('groupBy.label')}>
            <OptionMenu value={groupBy} options={options} onChange={onGroupByChange} />
          </Row>
          {groupBy !== GROUP_BY_TYPE && (
            <>
              <Divider my={2} />
              <Flex justify="flex-end" px={1.5} pb={0.5}>
                <Button
                  size="xs"
                  variant="ghost"
                  fontWeight="500"
                  color="redesign.text.muted"
                  _hover={{ color: 'redesign.text', bg: 'redesign.bg.hover' }}
                  onClick={() => onGroupByChange(GROUP_BY_TYPE)}
                >
                  {tm('display.reset')}
                </Button>
              </Flex>
            </>
          )}
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
}
